import { render, staticRenderFns } from "./DigitalClock.vue?vue&type=template&id=11c64936&"
import script from "./DigitalClock.vue?vue&type=script&lang=js&"
export * from "./DigitalClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports